import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { CmsBlogPageCategoryViewComponent } from '../../../cms/blog/page/category-view/cms-blog-page-category-view.component';
import { CmsBlogPagePostViewComponent } from '../../../cms/blog/page/post-view/cms-blog-page-post-view.component';
import { CmsBlogPageRootViewComponent } from '../../../cms/blog/page/root-view/cms-blog-page-root-view.component';
import { LocalICmsPage } from '../local/local-page';
import { PageViewAbstract } from './page-view.abstract';

@Component({
    selector: 'page-view',
    templateUrl: 'page-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ICmsClientModule,
        forwardRef(() => CmsBlogPagePostViewComponent),
        forwardRef(() => CmsBlogPageRootViewComponent),
        forwardRef(() => CmsBlogPageCategoryViewComponent)
    ]
})
export class PageViewComponent extends PageViewAbstract implements OnInit, OnDestroy {
    @Input()
    override model?: LocalICmsPage<IPageDataV3>;
}
